import type { ReactElement } from 'react';
import { InitialAllocationBadge } from './InitialAllocationBadge';
import { InitialAuthButtons } from './InitialAuthButtons';
import { InitialAuthDivider, InitialAuthDividerVariant } from './InitialAuthDivider';
import { InitialAuthFooter } from './InitialAuthFooter';
import { InitialAuthHeader } from './InitialAuthHeader';
import { InitialEmailSection } from './InitialEmailSection';
interface InitialAuthBodyProps {
    email: string;
    emailInputError: string;
    loadingApple: boolean;
    loadingGoogle: boolean;
    loadingEmail: boolean;
    onAppleAuth: () => void;
    onGoogleAuth: () => void;
    onEmailAuth: () => void;
    onEmailChange: (value: string) => void;
    onOpenTerms: () => void;
    onPrivacyClick: () => void;
}
export function InitialAuthBody({ email, emailInputError, loadingApple, loadingGoogle, loadingEmail, onAppleAuth, onGoogleAuth, onEmailAuth, onEmailChange, onOpenTerms, onPrivacyClick, }: InitialAuthBodyProps): ReactElement {
    return (
      <div data-el="Cauthmodal/InitialAuthBody/Root" key="initial" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <InitialAuthHeader />
        <InitialAllocationBadge />
        <InitialAuthButtons loadingApple={loadingApple} loadingGoogle={loadingGoogle} loadingEmail={loadingEmail} onAppleAuth={onAppleAuth} onGoogleAuth={onGoogleAuth}/>
        <InitialAuthDivider variant={InitialAuthDividerVariant.AuthOptions}/>
        <InitialEmailSection email={email} emailInputError={emailInputError} loadingApple={loadingApple} loadingGoogle={loadingGoogle} loadingEmail={loadingEmail} onEmailAuth={onEmailAuth} onEmailChange={onEmailChange}/>
        <InitialAuthDivider variant={InitialAuthDividerVariant.Footer}/>
        <InitialAuthFooter onOpenTerms={onOpenTerms} onPrivacyClick={onPrivacyClick}/>
      </div>
    );
}
